import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceAdapter, Device } from 'src/app/models/device.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  private _controller = 'devices';

  constructor(private _http: HttpClient, private _adapter: DeviceAdapter) { }

  getById(id: Number): Observable<Device>{
    return this._http.get<Device>(this._controller + '/' + id).pipe(map(item => this._adapter.adapt(item)));
  }

  save(data: Device): Observable<Object>{
    return this._http.post<Object>(this._controller, this._adapter.reverseAdapt(data));
  }

  update(data: Device): Observable<Object> {
    return this._http.put<Object>(this._controller, this._adapter.reverseAdapt(data));
  }
  
  // delete(id: any): Observable<Object>{
  //   return this._http.delete<Object>(this._controller + '/' + id);
  // }

}
